export default __webpack_public_path__ + "static/media/dragndroplum.771b9a6e.png";